import { render } from "./clipboard-button.vue?vue&type=template&id=29f45394&ts=true"
import script from "./clipboard-button.vue?vue&type=script&lang=ts"
export * from "./clipboard-button.vue?vue&type=script&lang=ts"

import "./clipboard-button.vue?vue&type=style&index=0&id=29f45394&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__